"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePartialMonth = exports.generateMonth = void 0;

var tslib_1 = require("tslib");

var date_fns_1 = require("date-fns");

var lodash_chunk_1 = tslib_1.__importDefault(require("lodash.chunk"));

var generateMonth = function generateMonth(_a) {
  var date = _a.date,
      _b = _a.dateOptions,
      dateOptions = _b === void 0 ? {} : _b;
  var _c = dateOptions.weekStartsOn,
      weekStartsOn = _c === void 0 ? 0 : _c;
  var daysInMonth = (0, date_fns_1.getDaysInMonth)(date);
  var startWeekday = ((0, date_fns_1.getDay)((0, date_fns_1.startOfMonth)(date)) - weekStartsOn + 7) % 7;
  var endWeekday = (0, date_fns_1.getDay)((0, date_fns_1.endOfMonth)(date)) - weekStartsOn;
  var gridDays = (0, lodash_chunk_1.default)(tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read((0, exports.generatePartialMonth)({
    length: startWeekday,
    date: date,
    isPrevious: true
  })), false), tslib_1.__read(Array.from({
    length: daysInMonth
  }, function (_, i) {
    return (0, date_fns_1.setDate)(date, i + 1);
  })), false), tslib_1.__read((0, exports.generatePartialMonth)({
    length: 6 - endWeekday,
    date: date,
    isNext: true
  })), false), 7);
  return gridDays;
};

exports.generateMonth = generateMonth;

var generatePartialMonth = function generatePartialMonth(_a) {
  var date = _a.date,
      isNext = _a.isNext,
      isPrevious = _a.isPrevious,
      length = _a.length;

  if (length >= 7) {
    return [];
  }

  if (isNext) {
    var nextMonth_1 = (0, date_fns_1.addMonths)(date, 1);
    return Array.from({
      length: length
    }, function (_, i) {
      return (0, date_fns_1.setDate)(nextMonth_1, i + 1);
    });
  }

  if (isPrevious) {
    var prevMonth_1 = (0, date_fns_1.subMonths)(date, 1);
    var prevMonthDays_1 = (0, date_fns_1.getDaysInMonth)(prevMonth_1);
    return Array.from({
      length: length
    }, function (_, i) {
      return (0, date_fns_1.setDate)(prevMonth_1, prevMonthDays_1 - i);
    }).reverse();
  }

  return Array.from({
    length: length
  }, function () {
    return date;
  });
};

exports.generatePartialMonth = generatePartialMonth;